import { UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getExtensionRequestsReport, useBaseReport } from 'api';
import { ReportResponse } from 'types';

export const useExtensionRequestsReport = (): UseQueryResult<ReportResponse> =>
  useBaseReport(API_QUERY_KEYS.getExtensionRequestsReport, getExtensionRequestsReport);
